import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Given a batch of calendar appointments, returns the ids of those whose patient
 * is a Follow-up (PD-1113): their last finished clinical Encounter before `before`
 * is within the past 3 years AND their most recent prior appointment (if any) was
 * Completed. Everything else — no prior finished Encounter, one older than 3
 * years, or a prior appointment that was cancelled / no-show / never completed —
 * is New. `before` is the start of the appointment's calendar day (viewer's
 * timezone), mirroring `getReturningPatientStatuses`.
 */
export const getAppointmentTypes = oc
  .route({ method: 'POST', path: '/v2/appointments/appointment-types' })
  .input(
    z.object({
      items: z.array(
        z.object({
          encounterId: z.string(),
          patientId: z.string(),
          // Strict ISO — `threeYearsBefore` date-maths this value.
          before: z.string().datetime(),
        }),
      ),
    }),
  )
  .output(
    z.object({
      followUpEncounterIds: z.array(z.string()),
    }),
  )
